import Vue from "vue";
import { countryOptions } from "@/resource/selectOptions";
import { companyRoleOptions } from "@/resource/selectOptions";
import { numberEmployeesOptions } from "@/resource/selectOptions";
import { industryOptions } from "@/resource/selectOptions"

export const formBus = new Vue({
  data: {
    fields: {
      //Signup Form
      firstName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      lastName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      country: {
        value: "ZA",
        options: countryOptions,
        validationIcon: "fas fa-check",
        valid: true,
        validationMessage: null
      },
      mobileNumber: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      email: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        timer: null,
        loading: false
      },
      termsAccepted: false,
      //Verify Form
      verificationCode: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        timer: null,
        loading: false
      },
      //Info Form
      companyName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null
      },
      campaignName: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        campaignSlug: '',
        timer: null,
        loading: false
      },
      industry: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        options: industryOptions
      },
      companyRole: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        options: companyRoleOptions
      },
      numberEmployees: {
        value: "",
        validationIcon: "",
        valid: null,
        validationMessage: null,
        options: numberEmployeesOptions
      },
      plan: {
        value: ""
      }
    },
    userData: {},
    error: false,
    errorMessage: "",
    notice: {
      open: false,
      message: "",
      title: "Notice",
      persistent: true,
    }
  }
});